import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const subHeading = Loadable(() => import('../../containers/web/subHeading'));
export default MapTo('vcg/components/soe-home/react/creditcheck/subHeading')(subHeading);
